<template>
  <div
    class="bg-ear"
    :class="{
      'bg-ear-full': full,
      'bg-ear-full-scale': scale,
      'up-close': upClose,
      'ear-video': video,
    }"
    :style="`backgroundImage:url('${imgSrc}'); z-index:${zIndex};`"
  >
    <video
      :poster="require(`@/assets/every-ear/0001.png`)"
      v-if="video"
      autoplay
      loop
      muted
      playsinline
      preload
    >
      <source :src="videoSrc" type="video/webm" />
    </video>
    <svg v-else viewBox="0 0 1366 700" width="100%"></svg>
  </div>
</template>

<script>
export default {
  name: "blade-ear",
  props: {
    id: Number,
    src: String,
    length: Number,
    full: Boolean,
    scale: Boolean,
    upClose: Boolean,
    video: { type: Boolean, default: false },
  },
  computed: {
    zIndex() {
      return this.length - this.id;
    },
    imgSrc() {
      return !this.video ? require(`@/assets/every-ear/${this.src}`) : "";
    },
    videoSrc() {
      return this.video ? `/img/sequences/earScan/${this.src}` : "";
    },
  },
};
</script>

<style scoped lang="scss">
.bg-ear {
  margin-top: auto;
  margin-bottom: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 700px;
  background-position: calc(50% - 348px) 0;
  background-repeat: no-repeat;
  z-index: -1;
  &-full {
    height: auto;
    background-size: cover;
    background-position: 50% 50%;
    &-scale {
      // background-position: calc(50% + 15.675674vw) 0%;
      background-position: calc(50% + 270px) 0%;
      transform: scale(2.8);
    }
  }
  video {
    position: relative;
    left: calc(50% - 700px);
    width: 700px;
    height: 700px;
  }
}
</style>
